import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import quizClient from '../../client/QuizClient';
import QuizInfoCard from '../../components/QuizInfoCard/QuizInfoCard';
import { Pagination, Spin, Row } from 'antd';
import usePagedList from '../../hooks/usePagedList';
import useIsMobile from '../../hooks/useIsMobile';

// Модульная функция: стабильная ссылка для эффекта загрузки в usePagedList
const fetchQuizzesPage = (deckId, pageIndex, pageSize) =>
    quizClient.getQuizzesByDeckId(deckId, { page: pageIndex, size: pageSize });

const QuizList = () => {
    const { t } = useTranslation();
    const {
        selectedDeck, items: quizzes, loading, total, currentPage, pageSize, setPage, updateItem,
    } = usePagedList(fetchQuizzesPage, t('list.loadQuizzesFailed'));
    const isMobile = useIsMobile();

    if (!selectedDeck) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('list.selectDeckForQuizzes')}</p>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', padding: '0px' }}>
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin tip={t('list.loadingQuizzes')} size="large" />
                </div>
            ) : (
                <>
                    {quizzes && quizzes.length > 0 ? (
                        quizzes.map((quiz) => (
                            <QuizInfoCard
                                key={quiz.id}
                                quiz={quiz}
                                onUpdateQuiz={updateItem}
                            />
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <p>{t('list.noQuizzes')}</p>
                        </div>
                    )}
                    {total > pageSize && (
                        <Row justify="center" style={{ marginTop: '20px' }}>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={total}
                                onChange={setPage}
                                simple={isMobile}
                                size={isMobile ? 'small' : 'default'}
                            />
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default QuizList;
